import request from '@/utils/request'


// 查询身材测试列表
export function listStature(query) {
  return request({
    url: '/stature/stature/list',
    method: 'get',
    params: query
  })
}

// 查询身材测试分页
export function pageStature(query) {
  return request({
    url: '/stature/stature/page',
    method: 'get',
    params: query
  })
}

// 查询身材测试详细
export function getStature(data) {
  return request({
    url: '/stature/stature/detail',
    method: 'get',
    params: data
  })
}

// 新增身材测试
export function addStature(data) {
  return request({
    url: '/stature/stature/add',
    method: 'post',
    data: data
  })
}

// 修改身材测试
export function updateStature(data) {
  return request({
    url: '/stature/stature/edit',
    method: 'post',
    data: data
  })
}

// 删除身材测试
export function delStature(data) {
  return request({
    url: '/stature/stature/delete',
    method: 'post',
    data: data
  })
}
